export default __webpack_public_path__ + "static/media/Icon-time-new.cee0a17f.svg";